module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter_hd"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("1.")]), _vm._v(" THE FERRY BUILDING MARKETPLACE AND FARMERS’ MARKET")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Visiting the Saturday-morning farmers’ market is a popular ritual for locals. With its historical building, waterfront views, and culinary delights, the bustling market is a feast for the eyes and stomach. Go early, as it gets crowded")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('strong', [_vm._v("DIFFICULTY: EASY")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("Begin in front of the "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("Ferry Building (1)")]), _vm._v(" (via bus #"), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("2")])]), _vm._v(", "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("6")])]), _vm._v(", "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("9")])]), _vm._v(", "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("14")])]), _vm._v(", "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("21")])]), _vm._v(", "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("31")])]), _vm._v(", or "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("F")])]), _vm._v(" train). This landmark was once one of the world’s busiest ferry terminals, but with the construction of the Golden Gate and Bay Bridges, the ferry business slowed. The building’s prominent role in city life declined, and the Embarcadero freeway went up in 1957. After the freeway was damaged in the 1989 Loma Prieta earthquake, it was dismantled, and the building was restored to its former glory. Today, vendors stocked with high-end delicacies line its airy corridors (open daily); You’ll find local purveyors of cheese, olive oils, produce, meats, chocolate, bread, and more. Notable stops include Blue Bottle Coffee, Hog Island Oyster Company, Book Passage, Miette for sweet confections, Cowgirl Creamery for cheese, Recchiuti Confections, The Gardener for kitchen and garden objects, and Heath Ceramics. Take a lunch break at retro-inspired Gott’s Roadside, Mijita, or Out the Door, the Vietnamese takeout stall of the restaurant The Slanted Door. You can’t really go wrong here, though—it’s all tantalizing and delicious. The dazzling farmers’ market takes place outside on Tuesdays, Thursdays, and Saturdays until 2 p.m. (there are fewer stands on weekdays). Don’t miss the Rancho Gordo heirloom beans, the Downtown Bakery sticky buns, or the Frog Hollow peaches (if they’re in season). At the far end, prepared foods—crab-cake sandwiches, rotisserie chickens with a cult following, and tacos—can be purchased and enjoyed at waterfront picnic tables. Work off lunch with a scenic stroll south along the Embarcadero. Admire the "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("“Cupid’s Span” (2)")]), _vm._v(", then catch the "), _c('span', {
    staticClass: "font2"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("N")])]), _vm._v(" train.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0fc0e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09-chapter01.vue
// module id = 81
// module chunks = 0